import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CustomPreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // Verifica se a rota deve ser pré-carregada
    if (route.data && route.data['preload']) {
      const delay = route.data['delay'] || 0;

      console.log(
        `[Preload] Pré-carregando rota: ${route.path} (delay: ${delay}ms)`,
      );

      // Pré-carrega após o tempo de atraso definido
      return timer(delay).pipe(mergeMap(() => load()));
    }

    // Não pré-carrega
    return of(null);
  }
}

@Injectable({ providedIn: 'root' })
export class NetworkAwarePreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // Verifica se a rota deve ser pré-carregada
    const shouldPreload = route.data && route.data['preload'];
    if (!shouldPreload) {
      return of(null);
    }

    // Verifica a conexão de rede
    const connection = (navigator as any).connection;
    if (connection) {
      // Não pré-carrega em conexões lentas (2G, slow-2g)
      if (
        connection.effectiveType === '2g' ||
        connection.effectiveType === 'slow-2g'
      ) {
        console.log(`[Preload] Ignorando ${route.path} devido à conexão lenta`);
        return of(null);
      }

      // Não pré-carrega se o usuário ativou o modo de economia de dados
      if (connection.saveData) {
        console.log(
          `[Preload] Ignorando ${route.path} devido à economia de dados`,
        );
        return of(null);
      }
    }

    console.log(`[Preload] Pré-carregando rota: ${route.path}`);
    return load();
  }
}
